import { useDispatchThunk } from "@common/redux/dispatchThunk";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { changeQueryFilters, setTags, newsSlice } from "@common/redux/slices/entities.slice";
import { ITag } from "@common/redux/types/tags";
import { FilterTags } from "@kursk/components/ui/FilterTags/FilterTags";
import { useDispatch } from "react-redux";

export function Filters() {
  const dispatch = useDispatch();
  const dispatchThunk = useDispatchThunk();
  const { meta, filters } = useSelectSlice(newsSlice);

  const onTagClick = async (tag: ITag) => {
    dispatch(setTags('news', tag));
    await dispatchThunk(changeQueryFilters('news'));
  }

  return (
    <>
      <FilterTags
        selected={filters?.allTags}
        tags={meta?.tags}
        onTagClick={onTagClick}
      />
    </>
  );
}
